import { app } from '../config/app.js';
import { collection, limit, where, startAfter, orderBy, setDoc, getDocs , query , getCountFromServer, doc,updateDoc, addDoc, getDoc, deleteDoc  } from "firebase/firestore";
import * as React from 'react';
import { GridActionsCellItem } from '@mui/x-data-grid';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import { Link } from 'react-router-dom';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { applyTrasformation } from './record.js';
import { QueryClient } from "@tanstack/react-query";

import { remoteLog } from './utils.js';
const queryClient = new QueryClient();
function getEndCharForStartBy(input) {
    const searchTerm = input.toLowerCase();
    const strlength = searchTerm.length;
    const strFrontCode = searchTerm.slice(0, strlength-1);
    const strEndCode = searchTerm.slice(strlength-1, searchTerm.length);
// This is an important bit..
    const endCode = strFrontCode + String.fromCharCode(strEndCode.charCodeAt(0) + 1);
    return endCode;
}

export function fsQuery(collezione,params) {
    
    let queryParams={
        "orderBy":app.collections_config[collezione].orderBy,
        "pageSize":app.defaultQueryLimit,
        "startAfter":0
    };
    if (app.collections_config[collezione].limit) queryParams=app.collections_config[collezione].limit;
    Object.keys(params).forEach((key) => {
        queryParams[key]=params[key];
    });
    
    
    let queryArgs=[];
    queryArgs.push(collection(app.db,collezione));
    let queryArgs2=[];
    queryArgs2.push(collection(app.db,collezione));
 //   
    if (queryParams["filters"] && !queryParams["where"]) {
        queryParams["where"]=[];
        Object.keys(queryParams["filters"]).forEach((key) => {
            const inputOperator=queryParams["filters"][key].type;
            switch (inputOperator) {
                case "equalTo":
                    queryParams["where"].push([key,'==',queryParams["filters"][key].value]);
                    break;
                case "startBy":
                    queryParams["where"].push([key,'>=',queryParams["filters"][key].value]);
                    queryParams["where"].push([key,'<=',getEndCharForStartBy(queryParams["filters"][key].value)]);
                    break;
                case "lowerThan":
                    queryParams["where"].push([key,'<',queryParams["filters"][key].value]);
                    break;
                    
                case "greaterThan":
                    queryParams["where"].push([key,'>',queryParams["filters"][key].value]);
                    break;
                    
                case "lowerEqualThan":
                    queryParams["where"].push([key,'<=',queryParams["filters"][key].value]);
                    break;
                case "greaterEqualThan":
                    queryParams["where"].push([key,'>=',queryParams["filters"][key].value]);
                    break;
                case "includedBy":

                    break;
                default:
                    break;
            }
        });
    }   
   // else {
        if (queryParams["orderBy"]) {
            if (Array.isArray(queryParams["orderBy"])) {
            queryArgs.push(orderBy(queryParams["orderBy"][0], queryParams["orderBy"][1]));
            } else {
            queryArgs.push(orderBy(queryParams["orderBy"], 'asc'));
            }
        }
    //}
    if (queryParams["startAfter"]) queryArgs.push(startAfter(queryParams["startAfter"]));
    if (queryParams["pageSize"]) queryArgs.push(limit(queryParams["pageSize"]));
    
    if (queryParams["where"]) {
        queryParams["where"].forEach((key) => {
            queryArgs.push(where(...key));
            queryArgs2.push(where(...key));
        });
    }
    
   // console.log("Restituisco elemento query su:");
   // console.log("Collezione",collezione);
    //console.log("Query params",queryParams);
    return {"query":query(...queryArgs),"queryNoLimit":query(...queryArgs2)};

}


export function getHeaderLabel(querySnapshot,view) {

}
export async function getDataByKey(collezione,key) {
    
  let cachedData=true;
  const docSnap =await queryClient.fetchQuery({
    queryKey: [collezione,key],
    queryFn: async () => {
              
      const docRef = doc(app.db, collezione, key);
      const docSnap = await getDoc(docRef);
      cachedData=false;
      console.log("FB: Query "+collezione+" GET  "+key+" done - Costo 1");
      
      remoteLog("firestore","GET "+collezione+" "+key+" Costo 1");
      return docSnap;
    },
    staleTime: 10*60*1000
  });
  if (cachedData) {
    console.log("FB: Query "+collezione+" GET "+key+" from cache");
    remoteLog("firestore","GET "+collezione+" "+key+" Costo 0 DA CACHE");
  }
return docSnap.data();
}
export async function decacheCollection(collezione) {
    queryClient.removeQueries([collezione]);
    console.log("Pulita cache da "+collezione);
}
export async function deleteDocElement(collezione,key) {
    const docRef = doc(app.db, collezione, key);
    await deleteDoc(docRef);
    decacheCollection(collezione);
    //queryClient.removeQueries([collezione]);

    
}
function applyFiltersTrasformation(filtersReceived,collectionName,viewConfig) {
    const newFilters=[];
    
    viewConfig.fieldList.forEach(element => {
        if (element.filter!=null)  {
          if (filtersReceived[element.field]!=null && filtersReceived[element.field].value!="") {
            const targetField=element.filter.targetField==null ? element.field : element.filter.targetField;
            newFilters[targetField]=filtersReceived[element.field];
            if (element.filter.trasformations!=null) {
              element.filter.trasformations.forEach(trasformation => {
                newFilters[targetField].value=applyTrasformation({[targetField]:newFilters[targetField].value},{...trasformation, "source":targetField});
              });
            }
          }
        }
      });
      return newFilters;
}
export async function getDataCount(collezione,view,params) {
  /*    console.log("Get dataview called");
      console.log("Collezione",collezione);
      console.log("View",view);
      console.log("Params",params);*/
      const newData = [];
      let docs=[];
      let rowsLength=0;
      let headers=[];
      let errorMessage="";
      try {
          if (params["filters"]) params["filters"]=applyFiltersTrasformation(params["filters"],collezione,view);
          const fsQueryObj=fsQuery(collezione,params);
          const stringFilters=getStringFiltersByParams(params);
          let cachedData=true;
          const queryCountRet =await queryClient.fetchQuery({
            queryKey: [collezione,stringFilters+"COUNT"],
            queryFn: async () => {
              const queryCountRet=await getCountFromServer(fsQueryObj["queryNoLimit"]);
              cachedData=false;
              console.log("FB: Query COUNT "+collezione+" filter "+stringFilters+" done - Costo 1 - ",collezione+" "+JSON.stringify(params.where));
              remoteLog("firestore","COUNT "+collezione+" "+stringFilters+" Costo 1 parametri "+JSON.stringify(params.where));
              return queryCountRet;
            },
            staleTime: 10*60*1000
          });
          if (cachedData) {
            console.log("FB: Query COUNT "+collezione+" filter "+stringFilters+" from cache");
            remoteLog("firestore","COUNT "+collezione+" "+stringFilters+" Costo 0 DA CACHE parametri");
          }
          rowsLength=queryCountRet.data().count;
          //console.log("FB: Count Query done - Costo 1 - ",collezione+" "+JSON.stringify(params.where));
          
        }
      catch (error) {        
        console.error('Errore nella query:', error);
        errorMessage=error.toString();
    }
    return {"header":headers,"body":newData,"rowsLength":rowsLength,"docs":docs,"error":errorMessage};
    
} 
export async function getData(collezione,view,params,modifyFunctions) {
/*    console.log("Get dataview called");
    console.log("Collezione",collezione);
    console.log("View",view);
    console.log("Params",params);*/
    const newData = [];
    let docs=[];
    let rowsLength=0;
    let headers=[];
    const componentParams=params.componentParams;
    //console.log("GetData ComponentParams",componentParams);
    const permission=(params.permission?params.permission:null);
    let errorMessage="";
    const user=(params.user?params.user:null);
    //const newHeaders = [];
    try {
        if (params["filters"]) params["filters"]=applyFiltersTrasformation(params["filters"],collezione,view);
        const fsQueryObj=fsQuery(collezione,params);
        const stringFilters=getStringFiltersByParams(params);        
        const queryObj=fsQueryObj["query"];
        if (params.pagination!=null) {
            
          
          
            
            let cachedData=true;
            const queryCountRet =await queryClient.fetchQuery({
              queryKey: [collezione,stringFilters+"COUNT"],
              queryFn: async () => {
                const queryCountRet=await getCountFromServer(fsQueryObj["queryNoLimit"]);
                cachedData=false;
                console.log("FB: Query COUNT "+collezione+" filter "+stringFilters+" done - Costo 1 - ",collezione+" "+JSON.stringify(params.where));
                remoteLog("firestore","COUNT "+collezione+" "+stringFilters+" Costo 1 parametri "+JSON.stringify(params.where));
                return queryCountRet;
              },
              staleTime: 10*60*1000
            });
            if (cachedData) {
              console.log("FB: Query COUNT "+collezione+" filter "+stringFilters+" from cache");
              remoteLog("firestore","COUNT "+collezione+" "+stringFilters+" Costo 0 DA CACHE parametri");
            }
            
            
            
            rowsLength=queryCountRet.data().count;
            
        }
        //const queryObj=query(collection(app.db,"users"));
        
        console.log("Cerco risultati in cache per collezione "+collezione+" e filtri "+stringFilters);
        let cachedData=true;
        const querySnapshot =await queryClient.fetchQuery({
          queryKey: [collezione,stringFilters],
          queryFn: async () => {
            const querySnapshot=await getDocs(queryObj);
            cachedData=false;
            console.log("FB: Query "+collezione+" filter "+stringFilters+" done - Costo "+querySnapshot.docs.length+" - ",collezione+" "+JSON.stringify(params.where));
            remoteLog("firestore","GET "+collezione+" "+stringFilters+" Costo "+querySnapshot.docs.length+" parametri "+JSON.stringify(params.where));
            return querySnapshot;
          },
          staleTime: 10*60*1000
        });
        if (cachedData) {
          console.log("FB: Query "+collezione+" filter "+stringFilters+" from cache");
          remoteLog("firestore","GET "+collezione+" "+stringFilters+" Costo 0 DA CACHE parametri");
        }
        //const querySnapshot=await getDocs(queryObj);
     /*   const querySnapshot=queryResult.data;
        const isCache = queryResult.isFetching === false;
        if (!isCache) 
        console.log("FB: Query done - Costo "+querySnapshot.docs.length+" - ",collezione+" "+JSON.stringify(params.where));
        else 
          console.log("FB: Query done - Cache - Costo 0 "+collezione+" "+JSON.stringify(params.where));
        *///console.log("Fs Query effettuata");
        
      /*  
        Object.keys(view.fieldList).forEach ((key) => {
            let headerName=key;
            if (view.fieldList[key].label) headerName=view.fieldList[key].label;
            if (typeof(modifyFunction)!=="undefined" && modifyFunctions["modifyHeaderField"]) headerName=modifyFunctions["modifyHeaderField"](collezione,view,key,headerName);
            
            newHeaders.push({key:key,label:headerName});
        });*/
        docs=querySnapshot.docs;
        if (params.pagination==null) rowsLength=docs.length;
        docs.forEach((doc) => {
            let element ={};
            
            const docData=doc.data();
            if (view) {
                Object.keys(view.fieldList).forEach ((rowNo) => {
                    const prop=view.fieldList[rowNo];
                    if (newData.length==0)
                        headers.push(prop);
                    const key=prop.field;
                    let value="";
                    if (key=="id")
                        value=doc.id;
                    else 
                        value=docData[key];
                        if (typeof(modifyFunction)!=="undefined" && modifyFunctions["modifyBodyField"]) value=modifyFunctions["modifyBodyField"](collezione,view,key,doc,value);
                    if (prop.type=="datetime" && value!==undefined && value && typeof(value.toDate)==="function")
                        value=value.toDate();
                    if (prop.type=="date" && value!==undefined && value && typeof(value.toDate)==="function") {
                        
                        value=value.toDate();
                    }
                    element[key]=value;
                });
                let editButton=false;
                if (permission.can_edit) {
                    editButton=true;
                    if (view.canEditRecord) editButton=app.services[view.canEditRecord].func(collezione,view,doc,permission,user);
                }
                let delButton=false;
                if (permission.can_del) {
                    delButton=true;
                    if (view.canDelRecord) delButton=app.services[view.canDelRecord].func(collezione,view,doc,permission,user);
                }
                element["docData"]=docData;
                if (!params.viewAction) {
                 /*   element["actions"]=[];
                    if (params.permission["show_action"]) {
                        element["actions"].push("viewButton");
                        if (editButton) element["actions"].push("editButton");
                        if (delButton) element["actions"].push("delButton");
                    }
                    if (componentParams && (componentParams.actions && componentParams.actions.length>0)) {
                        componentParams.actions.forEach(action => {
                        
                            element["actions"].push(action.name);
                        
                        });
                    } */
                }
            }
            else {
                element=docData;
                element.id=doc.id;
            }
            newData.push(element);
        });
    }
    catch (error) {        
        console.error('Errore nella query:', error);
        errorMessage=error.toString();
    }
    return {"header":headers,"body":newData,"rowsLength":rowsLength,"docs":docs,"error":errorMessage};
   
} 
function getStringFiltersByParams(params) {
  let stringFilters="";
        if (params.filters) {
        Object.keys(params.filters).forEach((key) => {
           stringFilters+=key+':"'+JSON.stringify(params.filters[key])+',"';
        });
        }
        return stringFilters;
}
const DynamicComponent = ({ type, params, collectionName , callerUrl}) => {
    console.log("DynamicComponent",collectionName, type,params);
    switch (type) {
      case 'viewButton':
        return (
          <Link to={`/`+collectionName+`/view`} state={{ data: { callerUrl:callerUrl, id: params.id, docData: params.row.docData } }}>
            <GridActionsCellItem data-target={params.id} icon={<VisibilityIcon />} label="Visualizza" />
            
          </Link>
        );
      case 'editButton':
        return (
          <Link to={`/`+collectionName+`/update`} state={{ data: { callerUrl:callerUrl, id: params.id, docData: params.row.docData } }}>
            <GridActionsCellItem icon={<EditIcon />} 
                label="Modifica" 
                data-target={params.id}
                //onClick={(pasrams) => callback["onEdit"](pasrams,params.id)}
            />
          </Link>
        );
      case 'delButton':
        return (
          <GridActionsCellItem
            icon={<DeleteIcon />}
            label="Elimina"
            onClick={() => console.log('Delete', params.id)}
          />
        );
      default:
        return null;
    }
  };
  const ActionsCell3 = () => {

    return [<div key="no-actions">No actions to display</div>];
  }
  const ActionCell = ({ record, action, currentPath }) => {
 
      const { label, icon, actionToDo, link, function: callback } = action;
     // console.log("Rendering action", { label, icon, actionToDo, link, callback, record, currentPath }); // Log per ciascuna azione
 
      // Verifica la condizione (se presente)
    //  if (condition && !condition(record)) return null;
  
      // Gestione del tipo di azione con switch
  switch (actionToDo) {
    case "link":
    //    console.log("Rendering Link action");
      // Se è un link, usa il componente Link
      return (
        <Link to={ typeof link === "function" ? link(record) : link } state={{
          data: {
            callerUrl: currentPath, // URL corrente
            id: record.id,
            docData: record, // Dati del record
          }
        }}>
          <GridActionsCellItem
            key={`link-${record.id}`}
            icon={icon}
            label={label}
            data-target={record.id}
            
          />
        </Link>
      );
    case "function":
      // Se è una funzione, esegui il callback
      return (
        <GridActionsCellItem
          icon={icon}
          label={label}
          onClick={() => callback && callback(record)}
        />
      );
    default:
      return null;
  }
};
  const ActionsCell = ({ record, actions = [], currentPath }) => {
   // console.log("Rendering ActionsCell", { record, actions, currentPath }); // Log per verificare se i dati sono corretti

    const renderAction = (action, index) => {
      const { label, icon, actionToDo, link, function: callback, condition } = action;
     // console.log("Rendering action", { label, icon, actionToDo, link, callback }); // Log per ciascuna azione
 
      // Verifica la condizione (se presente)
    //  if (condition && !condition(record)) return null;
  
      // Gestione del tipo di azione con switch
      switch (actionToDo) {
        case "link":
            console.log("Rendering Link action");
          // Se è un link, usa il componente Link
          return (
            <GridActionsCellItem
              key={`link-${index}`}
              icon={icon}
              label={label}
              component={Link}
             to={{
                pathname: typeof link === "function" ? link(record) : link, // Link dinamico
                state: {
                  data: {
                    callerUrl: currentPath, // URL corrente
                    id: record.id,
                    docData: record, // Dati del record
                  },
                },
              }}
              onClick={() => {
                // Assicurati che il link venga gestito correttamente
                console.log("Navigating to:", typeof link === "function" ? link(record) : link);
                console.log("State data:", {
                  callerUrl: currentPath,
                  id: record.id,
                  docData: record,
                });
              }}
            />
          );
        case "function":
          // Se è una funzione, esegui il callback
          return (
            <GridActionsCellItem
              key={`callback-${index}`}
              icon={icon}
              label={label}
                 onClick={() => callback && callback(record)}
            />
          );
        default:
          return null;
      }
    };
    return (
        <>
          {actions.length > 0 ? (
            actions.map(renderAction)
          ) : (
            <div>No actions to display</div>
          )}
        </>
      );
    };
export function getHeaders(collectionName,view,params,callback) {
        let docs=[];
        let rowsLength=0;
        let headers=[];
        const componentParams=params.componentParams;
        
        //const currentPath = params.currentPath;
        const currentPath="/"+collectionName;
       // console.log("Headers, componentParams",componentParams);
        const actions=[];
        if (view) {
            Object.keys(view.fieldList).forEach ((rowNo) => {
                const prop=view.fieldList[rowNo];
                let canView=true;
                if (prop.viewColumnFunction) canView=app.services[prop.viewColumnFunction].func(collectionName,view,params,prop);
                if (canView)
                    headers.push(prop);
            });
        }
        if ( !params.viewAction) {
            if (params.permission["show_action"]) {
                let actionToView=['view','edit','delete'];
                if (params.permission["actionsToView"]!=null) {
                  actionToView=params.permission["actionsToView"];
                }
                actionToView.forEach(action => {
                  switch (action) {
                    case 'view':
                        actions.push(
                      
                          {
                              label: "Visualizza",
                              icon: <VisibilityIcon />,
                            // dataTarget:record.id,
                              actionToDo: "link",  // Può essere "link" o "function"
                              link:"/"+collectionName+"/view"
                          }
                      );
                      break;
                    case 'edit':
                      actions.push(
                        {
                            label: "Modifica",
                            icon: <EditIcon />,
                            actionToDo: "link",  // Link
                            "link":"/"+collectionName+"/update"
                            //link: (record) => `/edit/${record.id}`,
                        });
                      break;
                    case 'delete':
                      actions.push(
                        {
                            label: "Elimina",
                            icon: <DeleteIcon />,
                            actionToDo: "function", // Funzione di callback
                            function: (record) => {
                                callback["onDelete"](params,record.id)
                            },
                        });
                      break;
                  
                    default:
                      break;
                  }
                });
                
                
                
                    

                
            }
            if (componentParams && (componentParams["actions"] && componentParams.actions.length>0)) {
                console.log("Ci sono azioni components action ",componentParams.actions);
                componentParams.actions.forEach(action => {
                    actions.push(action);
                });
            }
            if (actions.length>0) {
                headers.push({
                    field:"actions",
                    headerName:"Azioni",
                    width:150,
                  
                    type: "actions",
                    
                    getActions: (params) => {
                        const record = params.row; // Record corrente
                     //   console.log("GetActions",params);
                     //   console.log("Actions",actions);
                        return actions
                            .filter(action => !action.condition || action.condition(record)) // Filtro per le condizioni
                            .map((action, index) => (
                            <ActionCell
                                key={index}
                                action={action}
                                record={record}
                                currentPath={currentPath}
                            />
                            ));
                    },
                    renderCell2: (params) => {
                //        console.log("Render cell params", params);
                        
                        const currentPath="/"+collectionName;
                        return (
                        <>
                            {params.value.map((action, index) => (
                            <DynamicComponent callerUrl={currentPath} collectionName={collectionName} key={index} type={action} params={params} />
                            ))}
                        </>
                        )
                    
                    },
                    renderCell1: (params) => {
                        const value=params.value;
                       // console.log("Render cell params",params);
                        const addLink="/"+collectionName+"/update";
                        const viewLink="/"+collectionName+"/view";
                        const currentPath="/"+collectionName;
                        return (
                        
                        <>
                        { 
                        value.includes("viewButton") &&
                            <Link to={ viewLink }  state= {{ data: {callerUrl:currentPath, id:params.id, docData:params.row.docData }}} > 
                            <GridActionsCellItem
                                icon={<VisibilityIcon  />}
                                label="Visualizza"
                                data-target={params.id}
                                
                                onClick={(pasrams) => callback["onView"](pasrams,params.id)}
                            /></Link>}
                        { 
                        value.includes("editButton") &&
                            <Link to={ addLink }  state= {{ data: {callerUrl:currentPath, id:params.id, docData:params.row.docData }}} > 
                            <GridActionsCellItem
                                icon={<EditIcon />}
                                label="Modifica"
                                data-target={params.id}
                                onClick={(pasrams) => callback["onEdit"](pasrams,params.id)}
                            /></Link>}
                        { 
                        value.includes("delButton") &&
                        <GridActionsCellItem
                            icon={<DeleteIcon />}
                            label="Elimina"
                            data-target={params.id}
                            onClick={(pasrams) => callback["onDelete"](pasrams,params.id)}
                        />}
                        </>
                    )}
                });
            }
            
        }
        return headers;
       
    } 
const renderFunctions={
    "tableLayout":{
        "modifyFunctions": {
            
            "modifyHeaderField":function (collezione,view,key,value) {
                return "<th class='"+key+"'>"+value+"</th>";
            },
            
            "modifyBodyField":function (collezione,view,key,doc,value) {  
                const viewObj=app.collections_config[collezione].views[view];                
                const rawValue=(key==="id" ? doc.id:doc.data()[key]);
                return "<td class='"+key+"' data-key='"+key+"' data-value='"+rawValue+"'>"+value+"</td>";
            },
        }
    }   
}
export async function updateDocToDb(collezione,viewConfig,id,data) {
    if (typeof(data.id)==="undefined") data.id=null;
    if (id && data.id && id!==data.id) 
        return [false,"Non è consentito cambiare l'id a un documento"];
    
    if (!id) {
        try {
            if (data.id) {
                const forcedId=data.id;
                delete data.id;
                await setDoc(doc(app.db, collezione,forcedId),data);
                decacheCollection(collezione);
                //queryClient.removeQueries([collezione]);
                console.log("FB: Set Doc done",collezione+" "+forcedId);
            }
            else {
                await addDoc(collection(app.db, collezione),data);
                decacheCollection(collezione);
                //queryClient.removeQueries([collezione]);
                console.log("FB: Add Doc done " +collezione, data);
            }
            return [true,""];    
        }
        catch (error) {
            console.error("Errore aggiunta doc a firestore",error);
            console.error("Errore Data",data);
            return [false,error.toString()];
        }
    }

    try {
        
        const ref = doc(app.db, collezione, id);
        await updateDoc(ref,data);
        decacheCollection(collezione);
        console.log("FB: Update Doc",collezione+" "+id);
        
        remoteLog("firestore","Updated Doc "+collezione+" "+id);
        return [true,""];
    }
    catch (error) {
        console.error("Errore aggiunta doc a firestore",error);
        console.error("Errore Id",id);
        console.error("Errore Data",data);
        return [false,error.toString()];
    }
}
export async function getTableData(collezione,view,params) {
    const dataView= await getData(collezione,view,params,renderFunctions.tableLayout.modifyFunctions);
    //console.log("Get Data View returned element",dataView);
    let txt="<table class='coll-"+collezione+" tableLayoutData'>";
    txt+="<thead>";
    txt+=dataView.header.join("");
    txt+="</thead>";
    txt+="<tbody>";
    dataView.body.forEach((rowItemFields) => {
      //  let dataValues="";
        
        txt+="<tr >";
        Object.keys(rowItemFields).forEach((key) => {
            //       dataValues+=" data-"+key+"='"+rowItemFields[key]+"'";
            txt+=rowItemFields[key];           
        });

        txt+="</tr>";
    });
    txt+="</tbody>";
    txt+="</table>";
    return txt;
}